/** @format */

import { useState, useEffect } from "react";

import { HOST } from "constants.js";
import { AUTH_HEADERS } from "util/api";

import { useDispatch, useSelector } from "react-redux";
import * as a from "actiontypes";

export function useFetchSchedules(slug, getSchedule) {
	const [performers] = useState([]);
	const [scheduleLoading, setScheduleLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		async function fetchSchedules() {
			try {
				setScheduleLoading(true);
				const response = await fetch(`${HOST}api/v1/events/${slug}/schedule/?show_in=virtual`, {
					headers: AUTH_HEADERS,
				});
				const json = await response.json();
				if (response.ok) {
					dispatch({ type: "GET_SCHEDULE", payload: json });
				}
			} catch (error) {
				console.error("error: ", error);
			} finally {
				setScheduleLoading(false);
			}
		}
		if (getSchedule) {
			fetchSchedules();
		}
	}, [getSchedule]); // eslint-disable-line react-hooks/exhaustive-deps
	return [scheduleLoading, performers];
}

export function useFetchCalendarData(eventSlug) {
	const dispatch = useDispatch();
	const [calendarLoading, setCalendarLoading] = useState(false);
	const activeUser = useSelector(state => state.user);

	useEffect(() => {
		async function fetchCalendar() {
			if (!activeUser.guestuser) {
				try {
					setCalendarLoading(true);
					const response = await fetch(`${HOST}api/v1/calendars/${eventSlug}/`, { headers: AUTH_HEADERS });
					const json = await response.json();
					dispatch({ type: a.GET_CALENDAR, payload: json });
				} catch (error) {
					console.error("calendar error", error);
				} finally {
					setCalendarLoading(false);
				}
			}
		}
		fetchCalendar();
	}, [activeUser, eventSlug]); // eslint-disable-line react-hooks/exhaustive-deps

	return { calendarLoading };
}

export const useAddEventSlot = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(null);
	const [error, setError] = useState(null);
	const [ok, setOk] = useState(false);

	const addEventSlot = async (data, eventSlug) => {
		setLoading(true);

		try {
			const headers = AUTH_HEADERS;
			const response = await fetch(`${HOST}api/v1/calendars/${eventSlug}/event_timeslots/`, {
				headers: headers,
				method: "POST",
				body: JSON.stringify({ id: data.id }),
			});

			const json = await response.json();

			setStatus(response.status);
			setOk(response.ok);

			if (response.ok) {
				dispatch({ type: a.ADD_FAVORITE, payload: json });
				dispatch({
					type: a.ADD_ALERT,
					payload: { variant: "success", type: "ADD_FAVOURITE", data: json, setting: "other" },
				});
			}
		} catch (error) {
			console.error("Error adding event timeslot to favourites:", error);
			setError(error);
		} finally {
			setLoading(false);
		}
	};
	return { addEventSlot, status, loading, error, ok };
};

export const useDeleteEventSlot = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(null);
	const [error, setError] = useState(null);
	const [ok, setOk] = useState(false);

	const deleteEventSlot = async (data, eventSlug) => {
		setLoading(true);
		if (data && eventSlug) {
			try {
				const headers = AUTH_HEADERS;
				const response = await fetch(
					`${HOST}api/v1/calendars/${eventSlug}/event_timeslots/${parseInt(data.id)}/`,
					{
						headers: headers,
						method: "DELETE",
					}
				);

				setStatus(response.status);
				setOk(response.ok);

				if (response.ok) {
					dispatch({ type: a.DELETE_FAVORITE, payload: data.id });
					dispatch({
						type: a.ADD_ALERT,
						payload: { variant: "success", type: "REMOVE_FAVOURITE", data, setting: "other" },
					});
				}
			} catch (error) {
				console.error("Error deleting event timeslot to favourites:", error);
				setError(error);
			} finally {
				setLoading(false);
			}
		}
	};
	return { deleteEventSlot, status, loading, error, ok };
};
